var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"4"}},[_c('password-change',{attrs:{"emailToken":_vm.token},on:{"passwordChanged":function($event){return _vm.$router.push({ name: 'login', params: {} })}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }